import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-loan-lightning",
  "use": "icon-loan-lightning-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-loan-lightning\"><path stroke=\"#000\" stroke-linejoin=\"round\" stroke-opacity=\".45\" stroke-width=\"1.5\" d=\"M6.333 2h5.455L8.455 6.2H13L5.727 14l1.515-5.7H3L6.333 2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol